<script setup>
import { ref, defineExpose, defineEmits, watch } from 'vue';
import { ColorPicker } from 'vue3-colorpicker';
import 'vue3-colorpicker/style.css';

const props = defineProps({
  modelValue: {
    type: String,
    default: '',
  },
});

const pureColor = ref(props.modelValue);
const emit = defineEmits(['update:modelValue']);

function selectCor() {
  emit('update:modelValue', pureColor.value);
}

defineExpose({ props, pureColor });

watch(() => props.modelValue, (newValue) => {
  pureColor.value = newValue;
});

const config = ref({
  disableAlpha: true,
});
</script>

<template>
  <div>
    <ColorPicker v-bind="config" v-model:pureColor="pureColor" format="hex6" @pureColorChange="selectCor()" />
  </div>
</template>
